import { useState } from "react";
import {
    Box,
    TextField,
} from "@mui/material";
import AppButton from "../common/AppButton";
import { addPolicy, updatePolicy } from "../../features/policy/policySlice";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import { addPolicyDTO, putPolicyDTO } from "../../dtos/policy";
import { styles } from "./styles"
export const NewPolicyModel = (edit?: any, editableText?: any, setNewModelPolicy?: any) => {
    const {
        policyPayload,
    }: any = useAppSelector((state) => state.policy);
    const pharmacyID = Number(localStorage?.getItem("pharmacyId"));
    const dispatch = useAppDispatch();
    const [inputVal, setInputValue] = useState(edit?.editableText || "");
    const [error, setError] = useState(false);
    const [minError, setMinError] = useState(false);

    const onChangeText = (e: any) => {
        setInputValue(e.target.value);
        if (e?.target?.value?.length > 200) {
            setError(true);
        } else {
            setError(false);
        }
        if (e?.target?.value?.length === 0 || e?.target?.value?.trim() === 0) {
            setMinError(true)
        }
        else {
            setMinError(false)
        }
    }
    const handleSave = () => {
        if (inputVal?.length === 0 || inputVal?.trim() === '') {
            setMinError(true)
            return;
        }
        if (edit?.edit) {
            const payload: putPolicyDTO = {
                pharmacy_id: pharmacyID,
                policy: inputVal,
                policy_id: policyPayload?.policy?.id
            }
            dispatch(updatePolicy(payload));
        }
        else {
            const payload: addPolicyDTO = {
                pharmacy_id: pharmacyID,
                policy: inputVal,
            }
            dispatch(addPolicy(payload));
        }
        edit?.setNewModelPolicy(false)
    }
    return (
        <Box>
            <TextField
                placeholder="Description"
                multiline
                defaultValue={edit?.editableText || ""}
                onChange={onChangeText}
                rows={5}
                variant="outlined"
                error={error || minError}
                helperText={error ? "Character limit exceeded (200 characters max)" : minError ? "Enter Text Please" : ""}
                fullWidth
                sx={{
                    '& .MuiInputBase-root': {
                        paddingTop: '12px',
                        paddingBottom: '12px',
                        paddingLeft: '15px',
                    },
                    fontFamily: 'Arial, sans-serif',
                    fontSize: '14px',
                    color: '#333',
                }}
            />
            <Box sx={styles.modelSaveButtonBox}>
                <AppButton title={edit?.edit ? "Update" : "Save"} fontSize={"10px"} disabled={error || minError
                } onClick={handleSave} />
            </Box>
        </Box>
    )
}